import UserInfoMain from "../../component/Member/components/UserInfo/UserInfoMain";
import NavBar from "../../component/NavBar/NavBar";

function UserInfo() {
    return (
        <>
            <NavBar />
            <UserInfoMain />
        </>
    );
}

export default UserInfo;